/* src/app/timing/date-sheet/date-sheet.component.css */
.title {
  font-weight: bolder;
}
/*# sourceMappingURL=date-sheet.component.css.map */
